let placesLibraryPromise = null;
let placesLibrary = null;

export async function loadPlacesLibrary() {
  if (placesLibrary) {
    return placesLibrary;
  }
  if (!placesLibraryPromise) {
    if (typeof google === 'undefined' || !google.maps || typeof google.maps.importLibrary !== 'function') {
      return null;
    }
    placesLibraryPromise = google.maps.importLibrary('places')
      .then(lib => {
        placesLibrary = lib && lib.AutocompleteSuggestion && lib.Place ? lib : null;
        return placesLibrary;
      })
      .catch(() => null);
  }
  return placesLibraryPromise;
}

export function createSessionToken(lib) {
  if (!lib || !lib.AutocompleteSessionToken) {
    return null;
  }
  try {
    return new lib.AutocompleteSessionToken();
  } catch (e) {
    return null;
  }
}

export async function fetchAddressSuggestions(input, sessionToken = null, limit = 5) {
  const lib = await loadPlacesLibrary();
  if (!lib || !input) {
    return [];
  }
  try {
    const request = { input };
    if (sessionToken) {
      request.sessionToken = sessionToken;
    }
    const { suggestions } = await lib.AutocompleteSuggestion.fetchAutocompleteSuggestions(request);
    return (suggestions ?? [])
      .map(suggestion => suggestion.placePrediction)
      .filter(prediction => !!prediction)
      .slice(0, limit)
      .map(prediction => ({
        placeId: prediction.placeId,
        text: prediction.text?.text ?? '',
        prediction,
      }))
      .filter(item => !!item.text);
  } catch (e) {
    return [];
  }
}

export async function fetchPlaceLocation(item) {
  const lib = await loadPlacesLibrary();
  if (!lib || !item) {
    return null;
  }
  try {
    const place = item.prediction && typeof item.prediction.toPlace === 'function'
      ? item.prediction.toPlace()
      : new lib.Place({ id: item.placeId });
    await place.fetchFields({ fields: ['location', 'viewport'] });
    if (!place.location) {
      return null;
    }
    return {
      location: { lat: place.location.lat(), lng: place.location.lng() },
      viewport: place.viewport ?? null,
    };
  } catch (e) {
    return null;
  }
}
